import { Box, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react'
import { FunctionField, SimpleShowLayout, useRecordContext } from 'react-admin'
import CustomReferenceField from '../Common/CustomReferenceField';
import { formatDateTime } from '../../utils/DateTimeUtils';
import ImagePreviewerDialog from '../Common/ImagePreviewerDialog';
import { useAppSelector } from '../../store/hooks';
import { UserGroupsEnum } from '../../enums/UserGroupsEnum';

function ComboSalesDetails() {
    let record = useRecordContext();
    const userDetails = useAppSelector((state) => state.userDetails.value);
    let groupsArray: string[] = userDetails.adminUser.accessGroups; 
    
  return (
    <SimpleShowLayout>
            <div style={{ display: "grid", gridTemplateColumns: "33% 33% 33%"}}>
                <SimpleShowLayout>
                    <CustomReferenceField
                        label="Attributed To"
                        listName={"AdminUsers"}
                        source={"salesAttributedTo"}
                    />
                    <FunctionField
                        label="Sales Data Updated At"
                        render={(record?: any) =>
                            <span style={{ whiteSpace: 'nowrap' }}>{record?.salesLastUpdatedAt ? formatDateTime(record?.salesLastUpdatedAt) : 'Not Available'}</span>
                        }
                    />
                    <ComboCallLogsList url = {record?.salesCallLogs}/>
                    <ImageList urls={record?.salesImageUrls || []} />
                </SimpleShowLayout>
                {
                 groupsArray.includes(UserGroupsEnum.ADMIN) &&
                 <SimpleShowLayout>
                    <CustomReferenceField
                        label="Approved by"
                        listName={"AdminUsers"}
                        source={"salesApprovedBy"}
                    />
                    <FunctionField
                        label="Approved At"
                        render={(record?: any) =>
                            <span style={{ whiteSpace: 'nowrap' }}>{record?.salesApprovedAt ? formatDateTime(record?.salesApprovedAt) : 'Not Available'}</span>
                        }
                    />
                    <FunctionField
                        label="Approval Status"
                        render={(record: any) =>
                        record?.salesApprovalStatus ? record?.salesApprovalStatus : 'Not Available'
                    }
                    />
                    <FunctionField
                        label="Rejection Reason"
                        render={(record: any) =>
                        record?.salesRejectReason ? record?.salesRejectReason : 'Not Available'
                    }
                    />
                </SimpleShowLayout>
                }
            </div>
        </SimpleShowLayout>
  )
}

export default ComboSalesDetails


function ComboCallLogsList(props: any) {
    return (
      <Box>
          <Typography fontWeight={600} fontSize={'1.5vw'} mb={'1vw'}>Call Logs</Typography>
          <TableContainer>
              <Table>
                  <TableHead>
                      <TableRow>
                          <TableCell align={'left'}>S.No</TableCell>
                          <TableCell align={'left'}>Call Urls</TableCell>
                      </TableRow>
                  </TableHead>
                  <TableBody>
                      {props?.url?.length > 0 && props?.url?.map((link: any, index: number) => (
                          <TableRow key={index}>
                              <TableCell>{index+1}</TableCell>
                              <TableCell>
                              <Link href={link}>
                                  {link}
                              </Link>
                              </TableCell>
                          </TableRow>
                      ))}
                  </TableBody>
              </Table>
          </TableContainer>
      </Box>
    )
  }

  function ImageList(urls: any) {
    const [open, setOpen] = React.useState(false);
    const [src, setSrc] = React.useState("");
    const [type, setType] = React.useState<"image" | "video">("image");


    const openMedia = (url: string) => {
        setType(/\.(mp4|webm|ogg)$/i.test(url) ? "video" : "image");
        setSrc(url);
        setOpen(true);
    };

    
    
    return (
        <>
    <Typography fontWeight={600} fontSize={'1.5vw'} mb={'1vw'}>Images</Typography>  
      <div
        style={{
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
          marginTop: 12
        }}
      >
        {urls?.urls.map((url: any, idx: any) => (
          <img
            key={idx}
            src={url}
            alt="preview"
            onClick={() => openMedia(url)}
            style={{
              width: 100,
              height: 100,
              objectFit: "cover",
              borderRadius: 6,
              border: "1px solid #ccc"
            }}
          />
        ))}
      </div>
      {open && (
        <ImagePreviewerDialog
          src={src}
          open={open}
          type={type}
          onClose={() => setOpen(false)}
        />
      )}
      </>
    );
  }